import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, KeyRound, ScrollText } from "lucide-react";
import { IMG } from "@/data/alcott";

const ease = [0.22, 1, 0.36, 1];

// Discreet dark entry to The Secret Society — the gated members' & archival wing.
// The full members' experience (sigil auth) lives behind /gate.
export const Society = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-[#050505] font-body text-[#F4EFE6]" data-testid="society-entry">
      <div className="absolute inset-0">
        <img src={IMG.secret1} alt="" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/85 via-[#050505]/90 to-[#050505]" />
      </div>

      <Link to="/" className="absolute left-6 top-6 z-10 inline-flex items-center gap-2 font-body text-[0.65rem] uppercase tracking-[0.2em] text-[#F4EFE6]/50 transition-colors hover:text-[#C5A059]" data-testid="society-back">
        <ArrowLeft size={14} /> Sybils & Society
      </Link>

      <div className="relative z-10 mx-auto flex min-h-screen max-w-2xl flex-col justify-center px-6 text-center">
        <motion.div initial={{ opacity: 0, y: 28 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease }}>
          <KeyRound size={30} strokeWidth={1.25} className="mx-auto text-[#C5A059]" />
          <p className="mt-7 font-body text-[0.7rem] uppercase tracking-[0.34em] text-[#C5A059]">By Sigil Only</p>
          <h1 className="mt-5 font-serif text-[clamp(2.6rem,8vw,5.5rem)] font-light leading-[0.95] tracking-tight text-white">
            The <span className="italic text-[#C5A059]">Secret Society</span>
          </h1>
          <p className="mx-auto mt-7 max-w-lg font-body text-base leading-relaxed text-white/55">
            The gated editorial and archival wing of Sybils & Society. Within: deep-dive
            historical ciphers, ancestry research, rare literary pieces, and confidential
            cultural salons — accessible only to verified members.
          </p>

          <div className="mt-11 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <button
              onClick={() => navigate("/gate")}
              className="inline-flex items-center gap-2 rounded-full border border-[#C5A059] bg-[#C5A059] px-8 py-4 font-body text-[0.65rem] uppercase tracking-[0.22em] text-[#050505] transition-transform duration-300 hover:-translate-y-0.5"
              data-testid="society-enter-btn"
            >
              <KeyRound size={14} /> Present your Sigil
            </button>
            <button
              onClick={() => navigate("/mysteries")}
              className="inline-flex items-center gap-2 rounded-full border border-[#C5A059]/40 px-8 py-4 font-body text-[0.65rem] uppercase tracking-[0.22em] text-[#C5A059] transition-colors duration-300 hover:bg-[#C5A059]/10"
              data-testid="society-apply-btn"
            >
              <ScrollText size={14} /> Petition for admission
            </button>
          </div>

          <p className="mt-10 font-body text-[0.6rem] uppercase tracking-[0.24em] text-white/30">
            Discretion is the first rite.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default Society;
